import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/illustration-personality.svg")